import React from "react";

import { Switch } from "antd";

import FilterCollapseWrapper from "../filter_collapse_wrapper/filter_collapse_wrapper";

import "./switch_filter.less";

interface SwitchFilterGroupProps {
  title: string;
  switches: SwitchFilter[];
}

interface SwitchFilter {
  label: string;
  checked: boolean;
  onFilter: () => void;
}

const SwitchFilterGroup: React.FC<SwitchFilterGroupProps> = ({
  title,
  switches,
}) => {
  return (
    <FilterCollapseWrapper title={title}>
      <div
        className="filter-switch-wrapper"
        data-testid="filter-switch-wrapper"
      >
        {switches?.map((switchItem: SwitchFilter) => (
          <label key={switchItem.label}>
            <Switch
              data-testid="filter-switch"
              key={switchItem.label}
              checked={switchItem.checked}
              onChange={switchItem.onFilter}
            />
            {switchItem.label}
          </label>
        ))}
      </div>
    </FilterCollapseWrapper>
  );
};
export default SwitchFilterGroup;
